import { SORT } from '@/widgets/PaymentLinksHistoryFilters/model/constants'

const DEFAULT_STATE = {
  items: [],
  page: 1,
  limit: 10,
  total: null,
  loading: false,

  search: null,

  range: [],

  sort: SORT[0].value,
  filters: {
    invoice_form_statuses: [],
    statuses: [],
  },

  selectedStatus: 'all',
  statusCounts: {
    all: 0,
    active: 0,
    finished: 0,
  },
}

export default {
  ...DEFAULT_STATE,
}
